import { RootState } from '@/redux/store'
import { createSelector } from '@reduxjs/toolkit'

export const selectMenuData = (state: RootState) => state['@menu'].data

export const selectItemEntities = createSelector(
  (state: RootState) => state['@menu'],
  (menu) => menu?.itemEntities
)

export const selectCategoryEntities = createSelector(
  (state: RootState) => state['@menu'],
  (menu) => menu?.categoryEntities
)
